import { GLASS_HEIGHT_CORRECTION, GLASS_WIDTH_CORRECTION, GLASS_HEIGHT_CORRECTION_WINDOW, GLASS_WIDTH_CORRECTION_WINDOW, WINDOW_HEIGHT_CORRECTION, WINDOW_WIDTH_CORRECTION } from './data/corrections'
import GlassOrder from './data/GlassOrder'
import VentilationOrder from './data/VentilationOrder'
import WindowOrder from './data/WindowOrder'
import EmptyRow from './data/EmptyRow'

const initState = {
    rows: [
        new EmptyRow(),
        new EmptyRow(),
        new EmptyRow(),
        new EmptyRow(),
        new EmptyRow()
    ],
    glassOrders: [],
    ventilationOrders: [],
    windowOrders: [],
    corrections: {
        glass_height_correction: GLASS_HEIGHT_CORRECTION,
        glass_width_correction: GLASS_WIDTH_CORRECTION,
        glass_height_correction_window: GLASS_HEIGHT_CORRECTION_WINDOW,
        glass_width_correction_window: GLASS_WIDTH_CORRECTION_WINDOW,
        window_height_correction: WINDOW_HEIGHT_CORRECTION,
        window_width_correction: WINDOW_WIDTH_CORRECTION
    }
}

export default function orderApp(state = initState, action) {
    switch (action.type) {
        case 'ORDER_FORM_CHANGED': {

            const newRow = Object.assign({}, state.rows[action.index], {
                [action.name]: action.value
            })

            let newRows = Array.from(state.rows);
            newRows[action.index] = newRow;

            return Object.assign({}, state, {
                rows: newRows
            })
        }

        case 'ADD_ROW': {
            let newRows = Array.from(state.rows)
            newRows.push(new EmptyRow())

            return Object.assign({}, state, {
                rows: newRows
            })
        }

        case 'CORRECTIONS_CHANGED': {
            const newCorrections = Object.assign({}, state.corrections, {
                [action.name]: action.value
            });

            return Object.assign({}, state, {
                corrections: newCorrections
            })
        }

        case 'ORDER_FORM_SUBMITTED': {
            const newGlassOrders = state.rows.filter(row => !(row.number === '' || row.width === '' || row.height === '') ).map((row) => new GlassOrder(row, state.corrections))
            const newVentilationOrders = state.rows.filter(row => !(row.number === '' || row.width === '' || row.height === '' || row.ventilation === '') ).map((row) => new VentilationOrder(row, state.corrections))
            const newWindowOrder = state.rows.filter(row => !(row.number === '' || row.width === '' || row.height === '') ).filter(row => row.type === '2').map((row) => new WindowOrder(row, state.corrections))

            return Object.assign({}, state, {
                glassOrders: newGlassOrders,
                ventilationOrders: newVentilationOrders,
                windowOrders: newWindowOrder
            })
        }


        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/reducer.js